import { observer } from "mobx-react-lite";

import Categories from "./Categories";
import DeliveryInfo from "./DeliveryInfo";
import DesktopSearchBar from "./DesktopSearchBar";

const DesktopHeader = () => (
   <>
      <DesktopSearchBar />
      <Categories />
      <DeliveryInfo />
   </>
);

export default observer(DesktopHeader);
